import _BpGwTmGC4CtTBGZrbDUG from '../dictionary/actionLogger.json' with { type: 'json' };
import _mwHHZdsHMnvDMvGEVkUU from '../dictionary/applicationErrors.json' with { type: 'json' };
import _OY4ZfVNZDL0ygWKcG7oj from '../dictionary/assetLibraryAssistant.json' with { type: 'json' };
import _aMOJtqxsAoIfcdO4cpEN from '../dictionary/assetPanel.json' with { type: 'json' };
import _f0XwDzWXU4QEEaPqnTPN from '../dictionary/colorPicker.json' with { type: 'json' };
import _SbAkgjToD0Il8vXSRDoV from '../dictionary/designStudioEditor.json' with { type: 'json' };
import _BETCs7ya6gPW6fPeff5e from '../dictionary/designStudioLoader.json' with { type: 'json' };
import _dry3C4uyY3mnnn19VcXr from '../dictionary/floatingActionBar.json' with { type: 'json' };
import _ZwWT3JG60ZbAK5AnVvOR from '../dictionary/fontFamily.json' with { type: 'json' };
import _wEj74qEEPBaJsYAzdcTB from '../dictionary/imageEditPanel.json' with { type: 'json' };
import _4SHV3SLbgyMqOBYpoJUj from '../dictionary/imageQualityWarning.json' with { type: 'json' };
import _sOv1wLa8ydckDIC9EMB5 from '../dictionary/interactiveCanvas.json' with { type: 'json' };
import _xzhCoSgFJIHkqKFo6m6k from '../dictionary/onboardingTour.json' with { type: 'json' };
import _hMysoBOy8Udlcj5BoWSD from '../dictionary/saveIndicator.json' with { type: 'json' };
import _CocIq2hxU4E1Y77I7cYk from '../dictionary/textEditor.json' with { type: 'json' };
import _didtzzMlHNYMRln45hOc from '../dictionary/toolbar.json' with { type: 'json' };

export default {
  "actionLogger": _BpGwTmGC4CtTBGZrbDUG,
  "applicationErrors": _mwHHZdsHMnvDMvGEVkUU,
  "assetLibraryAssistant": _OY4ZfVNZDL0ygWKcG7oj,
  "assetPanel": _aMOJtqxsAoIfcdO4cpEN,
  "colorPicker": _f0XwDzWXU4QEEaPqnTPN,
  "designStudioEditor": _SbAkgjToD0Il8vXSRDoV,
  "designStudioLoader": _BETCs7ya6gPW6fPeff5e,
  "floatingActionBar": _dry3C4uyY3mnnn19VcXr,
  "fontFamily": _ZwWT3JG60ZbAK5AnVvOR,
  "imageEditPanel": _wEj74qEEPBaJsYAzdcTB,
  "imageQualityWarning": _4SHV3SLbgyMqOBYpoJUj,
  "interactiveCanvas": _sOv1wLa8ydckDIC9EMB5,
  "onboardingTour": _xzhCoSgFJIHkqKFo6m6k,
  "saveIndicator": _hMysoBOy8Udlcj5BoWSD,
  "textEditor": _CocIq2hxU4E1Y77I7cYk,
  "toolbar": _didtzzMlHNYMRln45hOc
};
